<script setup lang="ts">
import { EyeIcon } from '@heroicons/vue/24/outline'

interface Props {
  params: any
}

const props = defineProps<Props>()

function onClick() {
  props.params.onClick?.(props.params.data.uuid)
}
</script>

<template>
  <div class="flex items-center justify-center gap-2 h-full">
    <EyeIcon class="w-5 h-5 cursor-pointer hover:text-primary transition-colors" @click="onClick" title="Visualiser le ticket" />
  </div>
</template>

<style scoped>

</style>
